import { Box, Card, Grid } from '@mui/material';

function Layout(props) {
  if (window.cordova || props.fullWidth === true) {
    return(
      <Grid item xs={12}>
        {props.children}
      </Grid>
    )  
  } else {
    return(
      <Grid item xs={12} sm={10} md={8}>
        <Box p={2}>
        <Card>
          {props.children}
        </Card>
        </Box>
      </Grid>
    )
  }
}

export default Layout;